// **BEGIN** Hextom TMS Integration - DO NOT MODIFY
      var hextom_tms = {
        selectorInsertType:  "insert",
        regionType:  "region_name_currency_symbol",
        availableLocalesById: {},
        availableLocales: [],
        primaryLocaleById: {},
        merchantSelectedLocale: "shop_base",
        hasFlag: "yes",
        selectorFlagMap: {'en': 'en', 'it': 'it'},
        displayType: "language_name",
        fontColor: "#000000",
        backgroundColor: "#FFFFFF",
        backgroundOpacity: "1.0",
        buttonFontColor: "#FFFFFF",
        buttonBackgroundColor: "#000000",
        selectorType: "market_language",
        selectorStyle: "dropdown",
        hasFlagRegion: "yes",
        defaultRegion: "IT",
        primaryRegionById: {},
        availableRegionsByCode: {},
        availableRegions: [],
        primaryDomain: "",
        popupEnable: false,
        popupTextColor: "#000000",
        popupBgColor: "#FFFFFF",
        popupBtnTextColor: "#FFFFFF",
        popupBtnBgColor: "#000000",
        regions: [{"name": "Italy", "code": "IT", "currency": {"code": "EUR", "symbol": "\u20ac"}, "languages": {"Italiano": {"name": "Italiano (Italian)", "native_name": "Italiano", "code": "it", "default": true}, "English": {"name": "English", "native_name": "English", "code": "en", "default": false}}, "primary": true}],
      };
    // **END** Hextom TMS Integration - DO NOT MODIFY
        